import { render, staticRenderFns } from "./RegexList.vue?vue&type=template&id=050f4daa&scoped=true&"
import script from "./RegexList.vue?vue&type=script&lang=js&"
export * from "./RegexList.vue?vue&type=script&lang=js&"
import style0 from "./RegexList.vue?vue&type=style&index=0&id=050f4daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f4daa",
  null
  
)

export default component.exports